require('./bootstrap');
import './installCompositionApi.js'
require('../sass/app.scss');

import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import { vuetify } from './plugins/vuetify';
import * as VueGoogleMaps from 'vue2-google-maps';
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete';
import sendMessageToParent from "./composables/sendMessageToParent";
Vue.use(VueRouter);

let googleAPIKey = document.head.querySelector('meta[name="gmap-key"]');

Vue.use(VueGoogleMaps, {
     load: {
         key: googleAPIKey.content,
         libraries: 'places', // 'places,drawing,visualization'
     },
 });
Vue.use(VuetifyGoogleAutocomplete, {
    vueGoogleMapsCompatibility: true,
});

const router = new VueRouter({
    mode: 'history',
    routes: []
});

import { library } from '@fortawesome/fontawesome-svg-core'
import { faBed, faShower, faBuilding, faHouse, faWheelchairMove, faSliders, faXmark  } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faBed, faShower, faBuilding, faHouse, faWheelchairMove, faSliders, faXmark)

Vue.component('booking-form', require('./components/BookingForm.vue').default);
Vue.component('search', require('./components/Search.vue').default);
Vue.component('listing-details', require('./components/ListingDetails.vue').default);
Vue.component('eligibility-form', require('./components/EligibilityForm.vue').default);
Vue.component('application-form', require('./components/ApplicationForm.vue').default);
Vue.component('my-profile', require('./components/MyProfile.vue').default);
Vue.component('applications', require('./components/Applications.vue').default);
Vue.component('dashboard', require('./components/Dashboard.vue').default);
Vue.component('example', require('./components/Example.vue').default);
Vue.component('login', require('./components/Login.vue').default);
Vue.component('register', require('./components/Register.vue').default);
Vue.component('forgot-password', require('./components/ForgotPassword.vue').default);
Vue.component('forgot-password-password-form', require('./components/ForgotPasswordPasswordForm.vue').default);
Vue.component('email-verification', require('./components/EmailVerification.vue').default);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('listing-videos', require('./components/ListingVideos.vue').default);
Vue.component('listing-card-slider', require('./components/ListingCardSlider.vue').default);
Vue.component('login-menu', require('./components/LoginMenu.vue').default);

window.breakpoints = {};

function createVue () {
  return new Promise((resolve, reject) => {
    const app = new Vue({
        router,
        el: '#widget-app',
        vuetify,
    });

    resolve();
  })
}

createVue().then(() => {
    window.breakpoints = vuetify.framework.breakpoint;
    sendMessageToParent('kpro_widgets_initialised', 'true');

    const widgetsLoaded = new Event('widgetsLoaded');
    window.dispatchEvent(widgetsLoaded);
})
